/**
 * deviceDisplayName — single source of truth for how a device's
 * user-facing display name is computed across the frontend.
 *
 * The platform stores TWO distinct name fields per device (see
 * /app/memory/PRD.md and Project Work Scope Summary):
 *
 *   • ``name``         — Device Name. Set during initial registration,
 *                        admin-locked. Used in audit logs and internal
 *                        references. NEVER shown to end users.
 *   • ``asset_name``   — Asset Name. Editable by end users via Device
 *                        Configuration → Asset Type. Free-text label.
 *   • ``unit_number``  — Unit Number. Editable by end users alongside
 *                        the Asset Name. Free-text label, often the
 *                        rego or vehicle number.
 *
 * The "Phase 2" rollout (iter151) standardised the user-facing label as:
 *
 *     "<Asset Name> / <Unit Number>"  when both are present
 *     "<Asset Name>" or "<Unit Number>" when only one exists
 *     fall back to "<Device Name>" then "Unknown Device"
 *
 * Every user-facing surface (Live Tracking, Analytics, Operations,
 * Event Videos, Remote Downloads, Live Videos, Share Evidence pages,
 * Forensic Snapshot, search bars, dropdowns, toasts) MUST use this
 * helper or `formatAssetLabel` from `./deviceLabel.js` (same rule,
 * different name kept for callers that already use it).
 *
 * Mirrors the backend ``_device_display_name`` in routes_media.py so
 * server-rendered and client-rendered names stay in sync.
 */
import { formatAssetLabel } from './deviceLabel';

export const deviceDisplayName = (device) => {
  if (!device) return 'Unknown Device';
  const label = formatAssetLabel(device);
  return (label && label !== '-') ? label : 'Unknown Device';
};

export default deviceDisplayName;
